<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">库存列表</div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Row>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <RadioGroup v-model="status" type="button" button-style="solid">
                  <Radio :label="-1">全部库存</Radio>
                  <Radio :label="0">未出售</Radio>
                  <Radio :label="1">已出售</Radio>
                </RadioGroup>
                </Col>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Input v-model="searchValue" placeholder="搜索">
                <Select v-model="searchType" slot="prepend" style="width: 110px">
                  <Option :value="1">库存内容</Option>
                  <Option :value="2">商户订单号</Option>
                  <Option :value="3">商品ID</Option>
                </Select>
                <Button slot="append" icon="ios-search" @click="searchClick"></Button>
                </Input>
                </Col>
              </Row>


              <Button type="error" icon="md-trash" @click="allDel" :loading="loading"
                :disabled="Selection.length==0?true:false">删除所选</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon v-if="$store.state.isMobile">移动设备请左右滑动翻阅及操作</Alert>
              <Table ref="selection" border :loading="load" :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="content">
                  <span :class="row.status == 1 ? 'del' : ''">
                    {{ row.content }}</span>
                </template>
                <template slot-scope="{ row }" slot="goods">
                  <img :src="row.goods.front" alt="" :title="row.goods.name" class="shop-img" />
                </template>
                <template slot-scope="{ row }" slot="norms">
                  <span> {{ row.norms.name }}</span>
                </template>
                <template slot-scope="{ row }" slot="remarks">
                  <Button @click="remarksClick(row)" size="small">点击查看</Button>
                </template>
                <template slot-scope="{ row }" slot="status">
                  <span v-if="row.goods.stocktype == 1">
                    <Badge v-if="row.status === 0" status="success" text="未售" />
                    <Badge v-if="row.status === 1" status="error" text="已售" />
                  </span>
                  <span v-if="row.goods.stocktype == 2">
                    <Badge status="processing" v-if="row.status === 0 && row.goods.stocktype == 2" text="无限库存" />
                  </span>
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" :disabled="row.status?false:true"
                    @click="$router.push('/order/list?out_trade_no='+row.out_trade_no)">查看订单</Button>
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStock,
    delStock,
    getStockShop
  } from "@/api/admin";
  export default {
    data() {
      return {
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        searchValue: "",
        searchType: 1,
        status: -1,
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },

          {
            title: "库存内容",
            align: "center",
            slot: "content",
            minWidth: 200,
          },
          {
            title: "所属商品",
            align: "center",
            slot: "goods",
            minWidth: 100,
          },
          {
            title: "所属规格",
            align: "center",
            slot: "norms",
            minWidth: 180,
          },
          {
            title: "商户订单号",
            align: "center",
            key: "out_trade_no",
            minWidth: 220,
          },
          {
            title: "购买时间",
            align: "center",
            key: "buytime",
            minWidth: 200,
          },

          {
            title: "添加时间",
            key: "addtime",
            align: "center",
            minWidth: 200,
          },
          {
            title: "备注",
            align: "center",
            slot: "remarks",
            minWidth: 100,
          },
          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 120,
          },
          {
            title: "操作",
            minWidth: 160,
            align: "center",
            slot: "action",
            fixed: "right"
          },
        ],
        data: [],
        loading: false,
        load:true
      };
    },

    created() {
      this._getData();
    },
    watch: {
      status(newVal, oldVal) {
        if (newVal != oldVal) {
          (this.pageIndex = 1), (this.load = true), this._getData();
        }
      },
      searchValue(newVal) {
        if (newVal == "") {
          (this.pageIndex = 1), (this.load = true), this._getData();
        }
      }
    },
    methods: {
      // 搜索库存
      searchClick() {
        this.pageIndex = 1
        this.load = true
        this._getData();
      },
      // 获取列表
      _getData() {
        getStock({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          status: this.status,
          searchType: this.searchType,
          searchValue: this.searchValue,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.load = false
          this.Selection = [];
        });
      },

      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {

            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        this.load = true
        delStock({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false
          this.Selection = [];
        });
      },
      // 查看备注
      remarksClick(row) {
        this.$Notice.info({
          title: "备注",
          desc: row.remarks ? row.remarks : "暂无备注",
        });
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.pageIndex = 1
        this.load = true
        this.pageSize = val;
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
  .w50 {
    width: 50%;
  }

  .del {
    text-decoration: line-through;
    color: #999;
  }

  .shop-img {
    width: 36px;
    height: 36px;
    margin: 0 auto;
    border-radius: 5px;
  }
  /deep/ .ivu-radio-wrapper-checked {
    background: #2d8cf0;
    color: #fff;
  }
</style>